/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ImportIpynbMutationVariables = Types.Exact<{
  name: Types.Scalars["String"]["input"];
  contents: Types.Scalars["String"]["input"];
  importAsComponent: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type ImportIpynbMutation = {
  readonly __typename: "Mutation";
  readonly importIpynb: { readonly __typename: "Hex"; readonly id: c.HexId };
};

export type WarningsFragment = {
  readonly __typename: "ImportWarnings";
  readonly status: string | null;
  readonly categories: ReadonlyArray<string> | null;
  readonly projectSecrets: ReadonlyArray<string> | null;
  readonly sharedSecrets: ReadonlyArray<string> | null;
  readonly projectDataConnections: ReadonlyArray<c.DataConnectionId> | null;
  readonly sharedDataConnections: ReadonlyArray<c.DataConnectionId> | null;
  readonly sharedVcsPackages: ReadonlyArray<c.VcsPackageId> | null;
  readonly projectTitle: string | null;
  readonly projectLanguage: Types.ProjectLanguage | null;
  readonly cellIds: ReadonlyArray<c.StaticCellId> | null;
  readonly appLayout: ReadonlyArray<string> | null;
  readonly timezones: ReadonlyArray<string> | null;
  readonly exportedHexType: Types.HexType | null;
  readonly semanticProjects: ReadonlyArray<c.SemanticProjectId> | null;
  readonly components: ReadonlyArray<{
    readonly __typename: "ImportWarningComponent";
    readonly componentId: c.HexId;
    readonly version: c.HexVersionString;
  }> | null;
};

export type ImportProjectMutationVariables = Types.Exact<{
  contents: Types.Scalars["String"]["input"];
  importAsComponent: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type ImportProjectMutation = {
  readonly __typename: "Mutation";
  readonly importNewProject: {
    readonly __typename: "ImportNewProjectResult";
    readonly hex: { readonly __typename: "Hex"; readonly id: c.HexId };
    readonly warnings: {
      readonly __typename: "ImportWarnings";
      readonly status: string | null;
      readonly categories: ReadonlyArray<string> | null;
      readonly projectSecrets: ReadonlyArray<string> | null;
      readonly sharedSecrets: ReadonlyArray<string> | null;
      readonly projectDataConnections: ReadonlyArray<c.DataConnectionId> | null;
      readonly sharedDataConnections: ReadonlyArray<c.DataConnectionId> | null;
      readonly sharedVcsPackages: ReadonlyArray<c.VcsPackageId> | null;
      readonly projectTitle: string | null;
      readonly projectLanguage: Types.ProjectLanguage | null;
      readonly cellIds: ReadonlyArray<c.StaticCellId> | null;
      readonly appLayout: ReadonlyArray<string> | null;
      readonly timezones: ReadonlyArray<string> | null;
      readonly exportedHexType: Types.HexType | null;
      readonly semanticProjects: ReadonlyArray<c.SemanticProjectId> | null;
      readonly components: ReadonlyArray<{
        readonly __typename: "ImportWarningComponent";
        readonly componentId: c.HexId;
        readonly version: c.HexVersionString;
      }> | null;
    };
  };
};

export type ImportNewProjectVersionMutationVariables = Types.Exact<{
  contents: Types.Scalars["String"]["input"];
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type ImportNewProjectVersionMutation = {
  readonly __typename: "Mutation";
  readonly importNewVersion: {
    readonly __typename: "ImportNewVersionResult";
    readonly hexVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly version: c.HexVersionString;
    };
    readonly warnings: {
      readonly __typename: "ImportWarnings";
      readonly status: string | null;
      readonly categories: ReadonlyArray<string> | null;
      readonly projectSecrets: ReadonlyArray<string> | null;
      readonly sharedSecrets: ReadonlyArray<string> | null;
      readonly projectDataConnections: ReadonlyArray<c.DataConnectionId> | null;
      readonly sharedDataConnections: ReadonlyArray<c.DataConnectionId> | null;
      readonly sharedVcsPackages: ReadonlyArray<c.VcsPackageId> | null;
      readonly projectTitle: string | null;
      readonly projectLanguage: Types.ProjectLanguage | null;
      readonly cellIds: ReadonlyArray<c.StaticCellId> | null;
      readonly appLayout: ReadonlyArray<string> | null;
      readonly timezones: ReadonlyArray<string> | null;
      readonly exportedHexType: Types.HexType | null;
      readonly semanticProjects: ReadonlyArray<c.SemanticProjectId> | null;
      readonly components: ReadonlyArray<{
        readonly __typename: "ImportWarningComponent";
        readonly componentId: c.HexId;
        readonly version: c.HexVersionString;
      }> | null;
    };
  };
};

export const WarningsFragmentDoc = /*#__PURE__*/ gql`
  fragment WarningsFragment on ImportWarnings {
    status
    categories
    components {
      componentId
      version
    }
    projectSecrets
    sharedSecrets
    projectDataConnections
    sharedDataConnections
    sharedVcsPackages
    projectTitle
    projectLanguage
    cellIds
    appLayout
    timezones
    exportedHexType
    semanticProjects
  }
`;
export const ImportIpynbDocument = /*#__PURE__*/ gql`
  mutation ImportIpynb(
    $name: String!
    $contents: String!
    $importAsComponent: Boolean
  ) {
    importIpynb(
      name: $name
      contents: $contents
      importAsComponent: $importAsComponent
    ) {
      id
    }
  }
`;
export type ImportIpynbMutationFn = Apollo.MutationFunction<
  ImportIpynbMutation,
  ImportIpynbMutationVariables
>;

/**
 * __useImportIpynbMutation__
 *
 * To run a mutation, you first call `useImportIpynbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportIpynbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importIpynbMutation, { data, loading, error }] = useImportIpynbMutation({
 *   variables: {
 *      name: // value for 'name'
 *      contents: // value for 'contents'
 *      importAsComponent: // value for 'importAsComponent'
 *   },
 * });
 */
export function useImportIpynbMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportIpynbMutation,
    ImportIpynbMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportIpynbMutation, ImportIpynbMutationVariables>(
    ImportIpynbDocument,
    options,
  );
}
export type ImportIpynbMutationHookResult = ReturnType<
  typeof useImportIpynbMutation
>;
export type ImportIpynbMutationResult =
  Apollo.MutationResult<ImportIpynbMutation>;
export type ImportIpynbMutationOptions = Apollo.BaseMutationOptions<
  ImportIpynbMutation,
  ImportIpynbMutationVariables
>;
export const ImportProjectDocument = /*#__PURE__*/ gql`
  mutation ImportProject($contents: String!, $importAsComponent: Boolean) {
    importNewProject(
      contents: $contents
      importAsComponent: $importAsComponent
    ) {
      hex {
        id
      }
      warnings {
        ...WarningsFragment
      }
    }
  }
  ${WarningsFragmentDoc}
`;
export type ImportProjectMutationFn = Apollo.MutationFunction<
  ImportProjectMutation,
  ImportProjectMutationVariables
>;

/**
 * __useImportProjectMutation__
 *
 * To run a mutation, you first call `useImportProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importProjectMutation, { data, loading, error }] = useImportProjectMutation({
 *   variables: {
 *      contents: // value for 'contents'
 *      importAsComponent: // value for 'importAsComponent'
 *   },
 * });
 */
export function useImportProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportProjectMutation,
    ImportProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ImportProjectMutation,
    ImportProjectMutationVariables
  >(ImportProjectDocument, options);
}
export type ImportProjectMutationHookResult = ReturnType<
  typeof useImportProjectMutation
>;
export type ImportProjectMutationResult =
  Apollo.MutationResult<ImportProjectMutation>;
export type ImportProjectMutationOptions = Apollo.BaseMutationOptions<
  ImportProjectMutation,
  ImportProjectMutationVariables
>;
export const ImportNewProjectVersionDocument = /*#__PURE__*/ gql`
  mutation ImportNewProjectVersion($contents: String!, $hexId: HexId!) {
    importNewVersion(contents: $contents, hexId: $hexId) {
      hexVersion {
        id
        version
      }
      warnings {
        ...WarningsFragment
      }
    }
  }
  ${WarningsFragmentDoc}
`;
export type ImportNewProjectVersionMutationFn = Apollo.MutationFunction<
  ImportNewProjectVersionMutation,
  ImportNewProjectVersionMutationVariables
>;

/**
 * __useImportNewProjectVersionMutation__
 *
 * To run a mutation, you first call `useImportNewProjectVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNewProjectVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNewProjectVersionMutation, { data, loading, error }] = useImportNewProjectVersionMutation({
 *   variables: {
 *      contents: // value for 'contents'
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useImportNewProjectVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportNewProjectVersionMutation,
    ImportNewProjectVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ImportNewProjectVersionMutation,
    ImportNewProjectVersionMutationVariables
  >(ImportNewProjectVersionDocument, options);
}
export type ImportNewProjectVersionMutationHookResult = ReturnType<
  typeof useImportNewProjectVersionMutation
>;
export type ImportNewProjectVersionMutationResult =
  Apollo.MutationResult<ImportNewProjectVersionMutation>;
export type ImportNewProjectVersionMutationOptions = Apollo.BaseMutationOptions<
  ImportNewProjectVersionMutation,
  ImportNewProjectVersionMutationVariables
>;
